// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/assets/fonts/Causten-Thin.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/assets/fonts/Causten-ThinOblique.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/assets/fonts/Causten-ExtraLight.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../public/assets/fonts/Causten-ExtraLightOblique.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../public/assets/fonts/Causten-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../public/assets/fonts/Causten-LightOblique.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../public/assets/fonts/Causten-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../public/assets/fonts/Causten-RegularOblique.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../public/assets/fonts/Causten-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../public/assets/fonts/Causten-MediumOblique.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../public/assets/fonts/Causten-SemiBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../public/assets/fonts/Causten-SemiBoldOblique.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../public/assets/fonts/Causten-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../public/assets/fonts/Causten-BoldOblique.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../public/assets/fonts/Causten-ExtraBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../public/assets/fonts/Causten-ExtraBoldOblique.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../public/assets/fonts/Causten-Black.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../public/assets/fonts/Causten-BlackOblique.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  max-width: 100vw;
}

/* Define all Causten Fonts */

/* Causten Thin */
@font-face {
  font-family: 'Causten';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
  font-weight: 100;
  font-style: normal;
}

@font-face {
  font-family: 'Causten';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
  font-weight: 100;
  font-style: italic;
}

/* Causten ExtraLight */
@font-face {
  font-family: 'Causten';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
  font-weight: 200;
  font-style: normal;
}

@font-face {
  font-family: 'Causten';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('opentype');
  font-weight: 200;
  font-style: italic;
}

/* Causten Light */
@font-face {
  font-family: 'Causten';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('opentype');
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: 'Causten';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('opentype');
  font-weight: 300;
  font-style: italic;
}

/* Causten Regular */
@font-face {
  font-family: 'Causten';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('opentype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'Causten';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('opentype');
  font-weight: 400;
  font-style: italic;
}

/* Causten Medium */
@font-face {
  font-family: 'Causten';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('opentype');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'Causten';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('opentype');
  font-weight: 500;
  font-style: italic;
}

/* Causten SemiBold */
@font-face {
  font-family: 'Causten';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('opentype');
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'Causten';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('opentype');
  font-weight: 600;
  font-style: italic;
}

/* Causten Bold */
@font-face {
  font-family: 'Causten';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('opentype');
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: 'Causten';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('opentype');
  font-weight: 700;
  font-style: italic;
}

/* Causten ExtraBold */
@font-face {
  font-family: 'Causten';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('opentype');
  font-weight: 800;
  font-style: normal;
}

@font-face {
  font-family: 'Causten';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('opentype');
  font-weight: 800;
  font-style: italic;
}

/* Causten Black */
@font-face {
  font-family: 'Causten';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('opentype');
  font-weight: 900;
  font-style: normal;
}

@font-face {
  font-family: 'Causten';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('opentype');
  font-weight: 900;
  font-style: italic;
}


h1 {
  font-size: 2.4rem !important;
  font-weight: 700 !important;
}

h2 {
  font-size: 2.2rem !important;
  font-weight: 500 !important;
}

h3 {
  font-size: 1.8rem !important;
  font-weight: 400 !important;
}

h4 {
  font-size: 1.5rem !important;
  font-weight: 500 !important;
}

h5 {
  font-size: 1.3rem !important;
  font-weight: 600 !important;
}

h6 {
  font-size: 1.2rem !important;
  font-weight: 600 !important;
}




/* color codes */

/* Primary Colors */
.color-prim-cetacean-blue {
  background-color: #02042d !important;
  /* Color Code */
  color: #ffffff;
  /* Text Color */
}

.color-prim-cetacean-blue-50 {
  background-color: #e6e6ea !important;
  color: #000000;
  /* Adjust text color for contrast */
}

.color-prim-cetacean-blue-100 {
  background-color: #b1b1be !important;
  color: #000000;
}

.color-prim-cetacean-blue-200 {
  background-color: #8b8c9e !important;
  color: #ffffff;
  /* Adjust text color for contrast */
}

.color-prim-cetacean-blue-300 {
  background-color: #555772 !important;
  color: #ffffff;
}

.color-prim-cetacean-blue-400 {
  background-color: #353657 !important;
  color: #ffffff;
}

.color-prim-cetacean-blue-500 {
  background-color: #02042d !important;
  color: #ffffff;
}

.color-prim-cetacean-blue-600 {
  background-color: #020429 !important;
  color: #ffffff;
}

.color-prim-cetacean-blue-700 {
  background-color: #010320 !important;
  color: #ffffff;
}

.color-prim-cetacean-blue-800 {
  background-color: #010219 !important;
  color: #ffffff;
}

.color-prim-cetacean-blue-900 {
  background-color: #010213 !important;
  color: #ffffff;
}

/* Magenta Colors */
.color-magenta {
  background-color: #a10cb7 !important;
  /* Color Code */
  color: #ffffff;
}

.color-magenta-50 {
  background-color: #f6e7f8 !important;
  color: #000000;
}

.color-magenta-100 {
  background-color: #e2b4e9 !important;
  color: #000000;
}

.color-magenta-200 {
  background-color: #d48fde !important;
  color: #000000;
}

.color-magenta-300 {
  background-color: #c05ccf !important;
  color: #ffffff;
}

.color-magenta-400 {
  background-color: #b43dc5 !important;
  color: #ffffff;
}

.color-magenta-500 {
  background-color: #a10cb7 !important;
  color: #ffffff;
}

.color-magenta-600 {
  background-color: #930ba7 !important;
  color: #ffffff;
}

.color-magenta-700 {
  background-color: #720982 !important;
  color: #ffffff;
}

.color-magenta-800 {
  background-color: #590765 !important;
  color: #ffffff;
}

.color-magenta-900 {
  background-color: #44054d !important;
  color: #ffffff;
}

/* Gray Scale Colors */
.color-prim-gray-scale {
  background-color: #e6e6e6 !important;
  /* Color Code */
  color: #000000;
}

.color-prim-gray-scale-50 {
  background-color: #f7f7fb !important;
  color: #000000;
}

.color-prim-gray-scale-100 {
  background-color: #e6e6e6 !important;
  color: #000000;
}

.color-prim-gray-scale-200 {
  background-color: #8a8a8a !important;
  color: #ffffff;
}

.color-prim-gray-scale-300 {
  background-color: #555555 !important;
  color: #ffffff;
}

.color-prim-gray-scale-400 {
  background-color: #343434 !important;
  color: #ffffff;
}

.color-prim-gray-scale-500 {
  background-color: #010101 !important;
  color: #ffffff;
}

.color-prim-gray-scale-600 {
  background-color: #010101 !important;
  color: #ffffff;
}

.color-prim-gray-scale-700 {
  background-color: #010101 !important;
  color: #ffffff;
}

.color-prim-gray-scale-800 {
  background-color: #010101 !important;
  color: #ffffff;
}

.color-prim-gray-scale-900 {
  background-color: #000000 !important;
  color: #FFF;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,6BAA6B;;AAE7B,iBAAiB;AACjB;EACE,sBAAsB;EACtB,+DAAsE;EACtE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+DAA6E;EAC7E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,sBAAsB;EACtB,+DAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+DAAmF;EACnF,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;EACtB,+DAAuE;EACvE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+DAA8E;EAC9E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,sBAAsB;EACtB,+DAAyE;EACzE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+DAAgF;EAChF,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,+DAAwE;EACxE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+DAA+E;EAC/E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,sBAAsB;EACtB,gEAA0E;EAC1E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gEAAiF;EACjF,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;EACtB,gEAAsE;EACtE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gEAA6E;EAC7E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,sBAAsB;EACtB,gEAA2E;EAC3E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gEAAkF;EAClF,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;EACtB,gEAAuE;EACvE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gEAA8E;EAC9E,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;;;;AAKA,gBAAgB;;AAEhB,mBAAmB;AACnB;EACE,oCAAoC;EACpC,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,oCAAoC;EACpC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,oCAAoC;EACpC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  max-width: 100vw;\n}\n\n/* Define all Causten Fonts */\n\n/* Causten Thin */\n@font-face {\n  font-family: 'Causten';\n  src: url('../public/assets/fonts/Causten-Thin.otf') format('opentype');\n  font-weight: 100;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Causten';\n  src: url('../public/assets/fonts/Causten-ThinOblique.otf') format('opentype');\n  font-weight: 100;\n  font-style: italic;\n}\n\n/* Causten ExtraLight */\n@font-face {\n  font-family: 'Causten';\n  src: url('../public/assets/fonts/Causten-ExtraLight.otf') format('opentype');\n  font-weight: 200;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Causten';\n  src: url('../public/assets/fonts/Causten-ExtraLightOblique.otf') format('opentype');\n  font-weight: 200;\n  font-style: italic;\n}\n\n/* Causten Light */\n@font-face {\n  font-family: 'Causten';\n  src: url('../public/assets/fonts/Causten-Light.otf') format('opentype');\n  font-weight: 300;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Causten';\n  src: url('../public/assets/fonts/Causten-LightOblique.otf') format('opentype');\n  font-weight: 300;\n  font-style: italic;\n}\n\n/* Causten Regular */\n@font-face {\n  font-family: 'Causten';\n  src: url('../public/assets/fonts/Causten-Regular.otf') format('opentype');\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Causten';\n  src: url('../public/assets/fonts/Causten-RegularOblique.otf') format('opentype');\n  font-weight: 400;\n  font-style: italic;\n}\n\n/* Causten Medium */\n@font-face {\n  font-family: 'Causten';\n  src: url('../public/assets/fonts/Causten-Medium.otf') format('opentype');\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Causten';\n  src: url('../public/assets/fonts/Causten-MediumOblique.otf') format('opentype');\n  font-weight: 500;\n  font-style: italic;\n}\n\n/* Causten SemiBold */\n@font-face {\n  font-family: 'Causten';\n  src: url('../public/assets/fonts/Causten-SemiBold.otf') format('opentype');\n  font-weight: 600;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Causten';\n  src: url('../public/assets/fonts/Causten-SemiBoldOblique.otf') format('opentype');\n  font-weight: 600;\n  font-style: italic;\n}\n\n/* Causten Bold */\n@font-face {\n  font-family: 'Causten';\n  src: url('../public/assets/fonts/Causten-Bold.otf') format('opentype');\n  font-weight: 700;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Causten';\n  src: url('../public/assets/fonts/Causten-BoldOblique.otf') format('opentype');\n  font-weight: 700;\n  font-style: italic;\n}\n\n/* Causten ExtraBold */\n@font-face {\n  font-family: 'Causten';\n  src: url('../public/assets/fonts/Causten-ExtraBold.otf') format('opentype');\n  font-weight: 800;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Causten';\n  src: url('../public/assets/fonts/Causten-ExtraBoldOblique.otf') format('opentype');\n  font-weight: 800;\n  font-style: italic;\n}\n\n/* Causten Black */\n@font-face {\n  font-family: 'Causten';\n  src: url('../public/assets/fonts/Causten-Black.otf') format('opentype');\n  font-weight: 900;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Causten';\n  src: url('../public/assets/fonts/Causten-BlackOblique.otf') format('opentype');\n  font-weight: 900;\n  font-style: italic;\n}\n\n\nh1 {\n  font-size: 2.4rem !important;\n  font-weight: 700 !important;\n}\n\nh2 {\n  font-size: 2.2rem !important;\n  font-weight: 500 !important;\n}\n\nh3 {\n  font-size: 1.8rem !important;\n  font-weight: 400 !important;\n}\n\nh4 {\n  font-size: 1.5rem !important;\n  font-weight: 500 !important;\n}\n\nh5 {\n  font-size: 1.3rem !important;\n  font-weight: 600 !important;\n}\n\nh6 {\n  font-size: 1.2rem !important;\n  font-weight: 600 !important;\n}\n\n\n\n\n/* color codes */\n\n/* Primary Colors */\n.color-prim-cetacean-blue {\n  background-color: #02042d !important;\n  /* Color Code */\n  color: #ffffff;\n  /* Text Color */\n}\n\n.color-prim-cetacean-blue-50 {\n  background-color: #e6e6ea !important;\n  color: #000000;\n  /* Adjust text color for contrast */\n}\n\n.color-prim-cetacean-blue-100 {\n  background-color: #b1b1be !important;\n  color: #000000;\n}\n\n.color-prim-cetacean-blue-200 {\n  background-color: #8b8c9e !important;\n  color: #ffffff;\n  /* Adjust text color for contrast */\n}\n\n.color-prim-cetacean-blue-300 {\n  background-color: #555772 !important;\n  color: #ffffff;\n}\n\n.color-prim-cetacean-blue-400 {\n  background-color: #353657 !important;\n  color: #ffffff;\n}\n\n.color-prim-cetacean-blue-500 {\n  background-color: #02042d !important;\n  color: #ffffff;\n}\n\n.color-prim-cetacean-blue-600 {\n  background-color: #020429 !important;\n  color: #ffffff;\n}\n\n.color-prim-cetacean-blue-700 {\n  background-color: #010320 !important;\n  color: #ffffff;\n}\n\n.color-prim-cetacean-blue-800 {\n  background-color: #010219 !important;\n  color: #ffffff;\n}\n\n.color-prim-cetacean-blue-900 {\n  background-color: #010213 !important;\n  color: #ffffff;\n}\n\n/* Magenta Colors */\n.color-magenta {\n  background-color: #a10cb7 !important;\n  /* Color Code */\n  color: #ffffff;\n}\n\n.color-magenta-50 {\n  background-color: #f6e7f8 !important;\n  color: #000000;\n}\n\n.color-magenta-100 {\n  background-color: #e2b4e9 !important;\n  color: #000000;\n}\n\n.color-magenta-200 {\n  background-color: #d48fde !important;\n  color: #000000;\n}\n\n.color-magenta-300 {\n  background-color: #c05ccf !important;\n  color: #ffffff;\n}\n\n.color-magenta-400 {\n  background-color: #b43dc5 !important;\n  color: #ffffff;\n}\n\n.color-magenta-500 {\n  background-color: #a10cb7 !important;\n  color: #ffffff;\n}\n\n.color-magenta-600 {\n  background-color: #930ba7 !important;\n  color: #ffffff;\n}\n\n.color-magenta-700 {\n  background-color: #720982 !important;\n  color: #ffffff;\n}\n\n.color-magenta-800 {\n  background-color: #590765 !important;\n  color: #ffffff;\n}\n\n.color-magenta-900 {\n  background-color: #44054d !important;\n  color: #ffffff;\n}\n\n/* Gray Scale Colors */\n.color-prim-gray-scale {\n  background-color: #e6e6e6 !important;\n  /* Color Code */\n  color: #000000;\n}\n\n.color-prim-gray-scale-50 {\n  background-color: #f7f7fb !important;\n  color: #000000;\n}\n\n.color-prim-gray-scale-100 {\n  background-color: #e6e6e6 !important;\n  color: #000000;\n}\n\n.color-prim-gray-scale-200 {\n  background-color: #8a8a8a !important;\n  color: #ffffff;\n}\n\n.color-prim-gray-scale-300 {\n  background-color: #555555 !important;\n  color: #ffffff;\n}\n\n.color-prim-gray-scale-400 {\n  background-color: #343434 !important;\n  color: #ffffff;\n}\n\n.color-prim-gray-scale-500 {\n  background-color: #010101 !important;\n  color: #ffffff;\n}\n\n.color-prim-gray-scale-600 {\n  background-color: #010101 !important;\n  color: #ffffff;\n}\n\n.color-prim-gray-scale-700 {\n  background-color: #010101 !important;\n  color: #ffffff;\n}\n\n.color-prim-gray-scale-800 {\n  background-color: #010101 !important;\n  color: #ffffff;\n}\n\n.color-prim-gray-scale-900 {\n  background-color: #000000 !important;\n  color: #FFF;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
